import React from 'react';
import { withRouter } from 'react-router-dom';

class MudarSenha extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            email: JSON.parse(localStorage.usuarioInfo).email,
            senhaAtual: "",
            senhaNova: "",
            confSenhaNova: ""
        };

        this.changeSenhaAtual = this.changeSenhaAtual.bind(this);
        this.changeSenhaNova = this.changeSenhaNova.bind(this);
        this.changeConfSenhaNova = this.changeConfSenhaNova.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    changeSenhaAtual(e) {
        this.setState({ senhaAtual: e.target.value });
    }

    changeSenhaNova(e) {
        this.setState({ senhaNova: e.target.value });
    }

    changeConfSenhaNova(e) {
        this.setState({ confSenhaNova: e.target.value });
    }

    salvar() {

        this.setState({ disabled: true });

        if (this.state.senhaAtual === "") {

            this.props.errMsgHandler("Por favor, informe a sua senha atual.");
            this.setState({ disabled: false });

        } else if (this.state.senhaNova === "") {

            this.props.errMsgHandler("Por favor, informe a sua senha nova.");
            this.setState({ disabled: false });

        } else if (this.state.confSenhaNova === "") {

            this.props.errMsgHandler("Por favor, confirme a sua senha nova.");
            this.setState({ disabled: false });

        } else if (this.state.confSenhaNova !== this.state.senhaNova) {

            this.props.errMsgHandler("A confirmação está diferente da senha nova.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "email": this.state.email,
                "senha_atual": this.state.senhaAtual,
                "senha_nova": this.state.senhaNova
            };

            fetch("/api/usuario/mudarsenha", {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    localStorage.auth = responseJson.auth;

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Senha alterada com sucesso.");
                    this.props.history.push("/home");

                } else {

                    this.props.waitMsgHandler("");
                    this.props.errMsgHandler(responseJson.msg);
                    this.setState({ disabled: false });

                }

            });

        }

    }

    cancelar() {
        this.props.history.push("/home");
    }

    render() {
        return (
            <div>
               <h1 id="mudar-senha-titulo">Mudar Senha</h1><br />
                <p id="mudar-senha-txt">
                    Para mudar a sua senha, informe a senha atual e a senha nova.
                </p><br />
                <form id="mudar-senha-form">
                    <input type="password"
                        placeholder="Senha atual"
                        value={ this.state.senhaAtual }
                        onChange={ this.changeSenhaAtual } /><br />
                    <input type="password"
                        placeholder="Senha nova"
                        value={ this.state.senhaNova }
                        onChange={ this.changeSenhaNova } /><br />
                    <input type="password"
                        placeholder="Confirme a sua senha nova"
                        value={ this.state.confSenhaNova }
                        onChange={ this.changeConfSenhaNova } /><br />
                    <button type="button"
                        id="mudar-senha-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>Salvar</button>
                    <button type="button" id="mudar-senha-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                </form>
            </div>
        );
    }

}

export default withRouter(MudarSenha);

